<script setup>
</script>

<style>

</style>

<template>
    <label class="text-[#344054] text-sm font-medium">
        <slot></slot>
    </label>
</template>
